import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  inferenceTime: 0,
  uploadedImage: null,
  detectionImage: null,
  isDetecting: false,
  location: {latitude:-1, longitude : -1},
  numBoxes: 0,
  
};

const detectSlice = createSlice({
  name: "detect",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setInferenceTime: (state, action) => {
      state.inferenceTime = action.payload;
    },
    setUploadedImage: (state, action) => {
      state.uploadedImage = action.payload;
    },
    setDetectionImage: (state, action) => {
      state.detectionImage = action.payload;
    },
    setIsDetecting: (state, action) => {
      state.isDetecting = action.payload;
    },
    setLocation: {
      prepare(latitude, longitude){
          const payload = {latitude, longitude};
          return { payload: payload }
      },
      reducer: (state, action) => {
          // if(action.payload.latitude ==='' || action.payload.nationalID ==='' || action.payload.phoneNumber ===''){
          //     return state;
          // }
          state.location.latitude = action.payload.latitude;
          state.location.longitude = action.payload.longitude;
      }
  },
    setNumBoxes: (state, action) => {
      state.numBoxes = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setInferenceTime,
  setUploadedImage,
  setDetectionImage,
  setIsDetecting,
  setLocation,
  setNumBoxes,
} = detectSlice.actions;

export default detectSlice.reducer;